import { gql } from '@apollo/client';


export const GET_ADMIN_POSTS = gql `
  query admin_posts (
    $paging_offset: Int!,
    $paging_limit: Int!
  ) {
    adminPosts(
      pagingOffset: $paging_offset,
      pagingLimit: $paging_limit 
    ) {
      id
      text
      status
      imageUrl
      user {
        handle
        profile
      }
      createdAt
    }
  }
`

export const GET_USER_PROFILE_BY_ID = gql`
  query user_profile_by_id (
    $user_auth0_id: String!
  ) {
    userProfileById(
      userAuth0Id: $user_auth0_id
    ) {
      id
      auth0Id
      handle
      profile
      verified
      profilePhotoUrl
      role
      posts { id text imageUrl createdAt }
      publications { id status title headline uuid tags { name } }
      followers { handle profile auth0Id }
      following { handle profile auth0Id }
      isPremiumUser
      badges {
        id
        name
        createdAt
        updatedAt
        imageUrl
      }
    }
  }
`


export const GET_USER_PROFILE_BY_HANDLE = gql`
  query user_profile_by_handle (
    $handle: String!
  ) {
    userProfileByHandle(
      handle: $handle
    ) {
      id
      auth0Id
      handle
      profile
      verified
      posts { id text imageUrl createdAt }
      publications { id status title headline uuid tags { name } }
      followers { handle profile auth0Id }
      following { handle profile auth0Id }
      isPremiumUser
      badges {
        id
        name
        createdAt
        updatedAt
        imageUrl
      }
    }
  }
`

export const GET_PUBLIC_POSTS = gql `
  query public_posts (
    $user_auth0_id: String!,
    $paging_offset: Int!,
    $paging_limit: Int!
  ) {
    publicPosts(
      userAuth0Id: $user_auth0_id,
      pagingOffset: $paging_offset,
      pagingLimit: $paging_limit 
    ) {
      id
      text
      imageUrl
      status
      comments { content user { handle auth0Id profile } createdAt }
      reactions { reactionType user { handle auth0Id } }
      user {
        handle
        profile
      }
      createdAt
    }
  }
`

export const GET_PUBLICATIONS = gql`
  query publications(
    $paging_offset: Int!,
    $paging_limit: Int!,
    $search: String,
    $tag_names: [String!],
    $featured: Boolean
  ) {
    publications(
      pagingOffset: $paging_offset,
      pagingLimit: $paging_limit,
      search: $search,
      tagNames: $tag_names,
      featured: $featured
    ) {
      id
      uuid
      title
      userId
      kind
      headline
      featured
      coverMedia
      htmlContent
      user {
        profile
      }
      tags {
        name
      }
    }
  }
`

export const GET_RELATED_PUBLICATIONS = gql`
query related_publications(
  $number_of_publications: Int!,
  $publication_uuid: String!
) {
  relatedPublications(
    numberOfPublications: $number_of_publications,
    publicationUuid: $publication_uuid
  ) {
    id
    uuid
    title
    userId
    kind
    headline
    coverMedia
    user {
      profile
    }
    tags {
      name
    }
  }
}

`

export const GET_ADMIN_PUBLICATIONS = gql`
  query admin_publications(
    $paging_offset: Int!,
    $paging_limit: Int!
  ) {
    adminPublications(
      pagingOffset: $paging_offset,
      pagingLimit: $paging_limit
    ) {
      uuid
      title
      userId
      status
      kind
      headline
      featured
      coverMedia
      media
      htmlContent
      user {
        profile
      }
      tags {
        name
      }
    }
  }
`

export const GET_TAGS = gql`
  query tags(
    $featured: Boolean!
  ) {
    tags(
      featured: $featured
    ) {
      id
      name
    }
  }
`

export const GET_MY_PUBLICATIONS = gql`
  query myPublications(
    $user_auth0_id: String!
  ) {
    myPublications(userAuth0Id: $user_auth0_id) {
      id
      uuid
      title
      userId
      kind
      headline
      coverMedia
      status
      user {
        profile
      }
      tags {
        name
      }
    }
  }
`

export const GET_USER_COLLECTIONS = gql`
  query userCollections(
    $user_auth0_id: String!
    $include_private: Boolean
  ) {
    userCollections(userAuth0Id: $user_auth0_id, includePrivate: $include_private) {
      id
      uuid
      title
      description
      public
      itemsCount
      user {
        id
        auth0Id
      }
      collectionItems {
        id
        item {
          ... on Publication {
            id
            uuid
            title
          }
          ... on Post {
            id
            text
          }
        }
      }
    }
  }
`

export const GET_COLLECTION = gql`
  query collection($uuid: String!) {
    collection(uuid: $uuid) {
      id
      uuid
      title
      description
      public
      itemsCount
      user {
        id
        auth0Id
        handle
        profile
      }
      collectionItems {
        id
        position
        item {
          ... on Publication {
            id
            uuid
            title
            headline
            status
            coverMedia
            coverPhotoUrl
            tags {
              name
            }
            user {
              id
              handle
              profile
            }
          }
          ... on Post {
            id
            text
            imageUrl
            user {
              id
              handle
              profile
            }
            createdAt
          }
        }
      }
    }
  }
`

export const VIEW_PUBLICATION = gql`
  query publication(
    $uuid: String!
  ) {
    publication(uuid: $uuid) {
      uuid
      title
      userId
      status
      kind
      headline
      coverMedia
      coverPhotoUrl
      media
      htmlContent
      user {
        auth0Id
        handle
        profile
      }
      tags {
        name
      }
    }
  }
`

export const GET_SCHOOL_CLASSES = gql`
  query schoolClasses(
    $user_auth0_id: String!
  ) {
    schoolClasses(
      userAuth0Id: $user_auth0_id
    ) {
      uuid
      name
      professorName
    }
  }
`

export const VIEW_SCHOOL_CLASS = gql`
  query schoolClass(
    $uuid: String!
  ) {
    schoolClass(uuid: $uuid) {
      uuid
      name
      professorName
    }
  }
`

export const GET_GRADED_ASSIGNMENTS = gql`
  query gradedAssignments(
    $school_class_uuid: String!
  ) {
    gradedAssignments(
      schoolClassUuid: $school_class_uuid
    ) {
      uuid
      name
      originalText
      comments {
        uuid
        originalText
        commentText
        offsetStart
        offsetEnd
      }
    }
  }
`

export const GET_INPUT_ASSIGNMENTS = gql`
  query inputAssignments(
    $school_class_uuid: String!
  ) {
    inputAssignments(
      schoolClassUuid: $school_class_uuid
    ) {
      uuid
      name
    }
  }
`

export const VIEW_GRADED_ASSIGNMENT = gql`
  query gradedAssignment(
    $uuid: String!
  ) {
    gradedAssignment(uuid: $uuid) {
      uuid
      name
      originalText
      overallFeedback
      grade
      comments {
        uuid
        originalText
        commentText
        offsetStart
        offsetEnd
      }
    }
  }
`

export const VIEW_INPUT_ASSIGNMENT = gql`
  query inputAssignment(
    $uuid: String!
  ) {
    inputAssignment(uuid: $uuid) {
      uuid
      name
      user { profile }
      originalText
      tone
      style
      genre
    }
  }
`

export const SEARCH_USERS_BY_EMAIL = gql`
  query searchUsersByEmail($email: String!) {
    searchUsersByEmail(email: $email) {
      id
      auth0Id
      email
      handle
      profile
      verified
      profilePhotoUrl
      role
      isPremiumUser
      badges {
        id
        name
        createdAt
        updatedAt
        imageUrl
      }
    }
  }
`

export const GET_ALL_BADGES = gql`
  query getAllBadges {
    getAllBadges {
      id
      name
      createdAt
      updatedAt
      imageUrl
    }
  }
`

export const GET_ADMIN_TAGS = gql`
  query adminTags {
    adminTags {
      id
      name
      slug
      state
    }
  }
`
